<template>
  <div v-if="product">
    <div id="flap-front" ref="flapFront" :class="{ outlined: showOutlines }">
      <img :src="flapData.designEmblemAsset" />
      <img :src="flapData.calendariumAsset" />
    </div>

    <div id="flap-back" :class="{ outlined: showOutlines }">
      <EanLabel ref="flapBack" :product="product" :data="eanLabelData" type="sticker-standard" :country="culture.country" :language="culture.language" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { Culture } from '@/models/Global'
import { AvailableEanLabelData, AvailableFlapData, SimplifiedProduct } from '@/models/Product'
import EanLabel from '../ean/EanLabel.vue'

const props = defineProps<{
  sku?: string
  product: SimplifiedProduct
  flapData: AvailableFlapData
  eanLabelData: AvailableEanLabelData
  showOutlines?: boolean
  culture: Culture
}>()
</script>

<style lang="scss" scoped>
#flap-front {
  max-width: 40mm;
  min-width: 40mm;
  max-height: 54mm;
  min-height: 54mm;

  box-sizing: border-box;

  display: flex;
  flex-direction: column;

  gap: 6mm;
  padding-right: 4.5mm;
  padding-top: 1mm;

  flex-wrap: wrap;
  align-content: end;
  justify-content: center;

  position: relative;

  img {
    width: 23mm;
  }
}

.outlined {
  outline: 1px solid #ddd;
}

#flap-front,
#flap-back {
  border: none !important;
  margin: 0 !important;
  background-color: white;
  box-sizing: border-box !important;
}

#flap-back {
  overflow: hidden;
  position: relative;
  width: 40mm;
  height: 54mm;

  > * {
    // pre-transform size
    width: 54mm;
    height: 40mm;

    transform-origin: top right;
    transform: translate(-100%) rotate(-90deg);

    display: flex;
    justify-content: center;
    align-items: start;
    // position: absolute;
  }
}

.dev-img {
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 65mm;
}

// DEV

// .flap {
//   outline: 0.2px solid #0002;
//   margin: 12.5mm;

//   img {
//     filter: invert(42%) sepia(93%) saturate(1352%) hue-rotate(-30deg) brightness(119%) contrast(119%);
//   }
// }

// helper lines
// .wrapper {
//   height: 54mm;
//   width: 40mm;

//   .wrapper::before,
//   .wrapper::after {
//     content: '';
//     position: absolute;
//     background-color: #0003;
//     left: 0;
//     width: 100vw;
//     height: 0.5px;
//   }

//   &::before {
//     top: 12.4mm;
//   }
//   &::after {
//     top: 66.5mm;
//   }

//   .flap {
//     &::before,
//     &::after {
//       content: '';
//       position: absolute;
//       background-color: #0003;
//       top: 0;
//       width: 0.5px;
//       height: 100vh;

//       &::before {
//         left: 12.4mm;
//       }
//       &::after {
//         left: 52.5mm;
//       }
//     }
//   }
// }
</style>
